import { TicketProduct } from '@modules/ticket-fares-store';
import { TicketType } from './ticket-type.enum';

export interface ITicketProductWithBundleType extends TicketProduct {
  bundleType: TicketType;
}
